import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { ITopModelsPayload } from '../types';

/**
 * This is to track the models filter mutation keys in react query cache.
 */
export const FETCH_TOP_MODELS_QUERY = 'fetch-top-models-query-key';
/**
 * This performs a post request and retrieves the top models.
 */
export const useTopModelsQuery = (payload: ITopModelsPayload) => {
  const { by, fromDate, toDate } = payload;

  const {
    data: topModels,
    isPending,
    isError,
    error,
    refetch: callTopModels,
  } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [FETCH_TOP_MODELS_QUERY, by, fromDate, toDate],
    networkMode: 'always',
    queryFn: () => CUSTOMER_SERVICE_API.fetchAllTopModels(payload),
  });

  return {
    callTopModels,
    error,
    isError,
    isPending,
    topModels,
  };
};
